exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul[data-v-1c789a61]{padding-left:0;display:flex;flex-flow:row wrap}li[data-v-1c789a61]{list-style-type:none;padding:10px;transition:all .3s ease}.container[data-v-1c789a61]{max-width:100%;padding:.5em 2rem 2rem}.matchingCards[data-v-1c789a61]:hover{transform:scale(1.1)}.blockCursor[data-v-1c789a61]{cursor:not-allowed}.configurationCards[data-v-1c789a61]{background-color:#302f30;border-radius:7px;text-align:center;cursor:pointer;color:#fff;padding:5px}.configurationCards label[data-v-1c789a61],.configurationCards p[data-v-1c789a61]{margin:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1c789a61","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/app-matching.vue
// module id = 100
// module chunks = 0